import moment from "moment"
import { LocalDateTime, UtcDateTime } from "../models/CustomType"

const dateTimeFormat = "YYYY-MM-DDTHH:mm"

type GridComparatorFn<T> = (v1: T, v2: T) => number

const getDateInput = (
  date?: LocalDateTime | UtcDateTime | null
): LocalDateTime | UtcDateTime | null => {
  if (date == null) {
    return null
  }

  const trimmedDate = date.trim()

  return trimmedDate === "" ||
    trimmedDate.toLowerCase() === "undefined" ||
    trimmedDate.toLowerCase() === "null"
    ? null
    : trimmedDate
}

export const getNiceFormattedDate = (
  date?: UtcDateTime | null
): LocalDateTime => {
  const dateInput = getDateInput(date)

  return dateInput ? moment.utc(dateInput).local().format("lll") : ""
}

export const getNowDateTime = (): LocalDateTime => moment().format(dateTimeFormat)

export const getUtcDateTime = (date?: LocalDateTime | null): UtcDateTime => {
  const dateInput = getDateInput(date)

  return dateInput ? moment(dateInput).utc().format(dateTimeFormat) : ""
}

export const getLocalDateTime = (date?: UtcDateTime | null): LocalDateTime => {
  const dateInput = getDateInput(date)

  return dateInput ? moment.utc(dateInput).local().format(dateTimeFormat) : ""
}

export const getFutureDateTime = (period: number): LocalDateTime =>
  moment().add(period, "days").format("lll")

export const compareDates = (d1: LocalDateTime, d2: LocalDateTime): number =>
  moment(d1).unix() - moment(d2).unix()

export const dateStringComparator: GridComparatorFn<string> = (v1, v2) =>
  compareDates(v1, v2)
